/**
 * Base URL for API v1 (same logic as services/api.js) for fetch() outside axios.
 */
export function getApiV1BaseUrl() {
  const env = process.env.REACT_APP_API_URL;
  if (env && String(env).trim()) return String(env).replace(/\/$/, '');
  if (typeof window !== 'undefined') return `${window.location.origin}/api/v1`;
  return '/api/v1';
}
